import Vue from "vue";
import { showToast } from "@/common/toast.service.js";
import { resourceModules } from "@/common/resources/";

export const bus = new Vue({
  methods: {
    register({ v, switchingBehavior, type, resourceName }) {
      resourceName = resourceName || "resource";

      function cancel() {
        const nextComponent = v.$route.name.split("-")[0].concat("-detail");
        v.$router.push({ name: nextComponent, params: v.$route.params });
      }
      function edit() {
        const nextComponent = v.$route.name.split("-")[0].concat("-edit");
        v.$router.push({ name: nextComponent, params: v.$route.params });
      }

      const handler = switchingBehavior === "flip" ? v : { cancel, edit };

      // Canclling-event handler (move UI from editing view back to detail view)
      this.$on("cancelling-event", handler.cancel);

      // Editing-event handler (move UI from detail view to edit view)
      this.$on("editing-event", handler.edit);

      // Handle a placing-event (adding a doc to a space)
      this.$on("placing-event", spaceID => {
        setTimeout(() => {
          console.log(`PLACE ${type}(${v[resourceName].id}) in ${spaceID}`);
          this.$emit("placing-complete", spaceID);
          showToast("Successfully added! 🎉", "is-success");
        }, 1000);
      });

      // Handle a Deleting-event (remove doc)
      this.$on("deleting-event", () => {
        setTimeout(() => {
          console.log(`DELETE ${type} ${v[resourceName].id}`);
          this.$emit("deleting-complete");
          showToast("Successfully deleted.", "is-danger");
        }, 1000);
      });

      // Handle a saving-event (PATCH a doc's metadata)
      this.$on("saving-event", async () => {
        let moduleRef;

        // Find the reference for the common layout
        for (let refKey in v.$refs) {
          if (refKey.match(/Common.*sLayout/gi)) moduleRef = v.$refs[refKey];
        }

        if (!moduleRef)
          throw new Error(`Unable to find a common layout for type: ${type}`);

        const { fields } = moduleRef.$refs.observer;
        const newFields = moduleRef.$refs.form;
        const editedFieldNames = Object.keys(fields)
          .filter(f => fields[f].changed || fields[f].dirty)
          .map(f => f.toLowerCase());

        const updatedFields = Object.keys(v[resourceName]).reduce((acc, p) => {
          // If current field name in the resource is found in editedFieldNames list, add to accumulator
          if (editedFieldNames.includes(p)) acc[p] = newFields[p];
          return acc;
        }, {});
        console.log(`SAVE ${type} ${v[resourceName].id}`);

        const Resource = resourceModules[type];
        let updatedResource;
        try {
          updatedResource = await new Resource({
            id: v[resourceName].id,
            ...updatedFields,
          }).$update();
          showToast("Saved!", "is-success");
        } catch (E) {
          showToast(`${E.description}\n${E.error}`, "is-danger", 5000);
        }
        this.$emit("saving-complete", updatedResource);
      });
    },
  },
});
